import axios from "axios";
import { SESSION_TOKEN, API_ROOT, ROOT } from "../constants/constants";
import _authService from "./authService";

export const instance = axios.create({
  baseURL: API_ROOT,
  headers: {
    "Content-Type": "application/json",
    'auth-token': localStorage.getItem(SESSION_TOKEN),
  },
});



// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // const token = window.sessionStorage.getItem(SESSION_TOKEN);
    const token = localStorage.getItem(SESSION_TOKEN);
    if (token) {
      config.headers['auth-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response) {
      // Request made and server responded anauthorised then logout
      var statusCode = error.response.status;
      // alert(statusCode)
      if (statusCode == 403 || statusCode == 401) {
        _authService.userLogout();
      }
      return Promise.reject(error.response.status);
    }
    return Promise.reject(error);
  }
);

// This instance is created to call StartAllService Api without appending /API before API name
// This will call api as http://xx.xx.xx.xx:xxxx/apiName
export const instanceRoot = axios.create({
  baseURL: API_ROOT,
  // headers: {
  //   "Content-Type": "application/json"
  // },
});

// Request interceptor
instanceRoot.interceptors.request.use(
  (config) => {
    // const token = window.sessionStorage.getItem(SESSION_TOKEN);
    const token = localStorage.getItem(SESSION_TOKEN);
    if (token) {
      config.headers['auth-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
instanceRoot.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response) {
      // Request made and server responded anauthorised then logout
      var statusCode = error.response.status;
      // alert(statusCode)
      if (statusCode == 403 || statusCode == 401) {
        _authService.userLogout();
      }
      return Promise.reject(error.response.status);
    }
    return Promise.reject(error);
  }
);